<template>
  <zg-module
    v-bind="moduleProps"
    :class="{ 'zg-module--structured' : structured }"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <zg-grid
      v-if="items && items.length"
      :columns="1"
      :m-columns="structured ? 2 : 1"
      :l-columns="structured ? 3 : 1"
    >
      <zg-link-list
        v-for="(item, index) in items"
        :key="index"
        :title="item.title"
        :items="item.items"
        :background="cardBackground"
        :structured="structured"
        :show-more-text="showMoreText"
        :show-less-text="showLessText"
      />
    </zg-grid>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgGrid from '../../layout/grid/ZgGrid'
  import ZgLinkList from '../../ZgLinkList/ZgLinkList.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgLinkListSection',
    components: {
      ZgGrid,
      ZgModule,
      ZgLinkList
    },
    mixins: [module],
    props: {
      items: {
        type: Array,
        required: true
      },
      structured: {
        type: Boolean,
        required: false,
        default: true
      },
      showMoreText: {
        type: String,
        required: false,
        default: ''
      },
      showLessText: {
        type: String,
        required: false,
        default: ''
      }
    }
  }
</script>

<style scoped lang="scss">

.zg-module--structured {
  ::v-deep > div {
    padding-right: rhythm(small);
    padding-left: rhythm(small);
  }
}
</style>
